import React, { useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { Link, useNavigate } from 'react-router-dom';

export default function CartPage() {
  const { cart, updateQuantity, removeItem } = useContext(CartContext);
  const navigate = useNavigate();

  function buildMessageFromCart(items) {
    if (!items || items.length === 0) return 'Customer has no items in cart.';
    const lines = items.map(i => `- ${i.name} (${i.category}) x ${i.quantity}`);
    return `Customer is interested in the following items:\n${lines.join('\n')}\n\nPlease follow up for order details.`;
  }

  function onCheckout() {
    const message = buildMessageFromCart(cart);
    navigate('/contact', { state: { prefillMessage: message, fromCart: true } });
  }

  return (
    <div className="container app-content" style={{ paddingTop: 12 }}>
      <h2 className="page-title">Your Cart</h2>

      {cart.length === 0 ? (
        <div className="alert" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Your cart is empty.</span>
          <Link to="/" className="btn secondary" style={{ textDecoration: 'none' }}>Browse</Link>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          <div style={{ display: 'grid', gap: 12 }}>
            {cart.map(item => (
              <div key={`${item.id}-${item.category}`} className="card" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ flex: '1 1 auto' }}>
                  <div style={{ fontWeight: 700 }}>{item.name}</div>
                  <div style={{ color: '#6b7280', marginTop: 6 }}>{item.description}</div>
                  <div style={{ marginTop: 8, color: '#475569', fontSize: 13 }}>{item.category}</div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={e => updateQuantity(item.id, item.category, Math.max(1, Number(e.target.value) || 1))}
                    className="qty"
                  />
                  <button onClick={() => removeItem(item.id, item.category)} className="btn secondary">Remove</button>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
            <button onClick={onCheckout} className="btn positive">Checkout</button>
          </div>
        </div>
      )}
    </div>
  );
}
